import strings_en from './strings_en.json'
import strings_fa from './strings_fa.json'

export default function getStringsBasedLang(selected_string) {
    var lang = localStorage.getItem("lang")

    if (lang == "fa") {
        return strings_fa[selected_string]
    }
    else {
        return strings_en[selected_string]
    }
}